import React, { Fragment, useRef, useState } from "react";

import { Link } from "react-router-dom";
import classnames from "classnames";
import {
  Alert,
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import {
  FetchAxiosFile,
  FetchAxiosPost,
  FetchAxiosPut,
} from "../../api/axios";
import { useEffect } from "react";
import LoadingData from "../TESTPage/LoadingData";
import { Tooltip } from "@mui/material";
import ConfirmModal from "../../components/Common/ConfirmModal";
import EvaluateFormHeader, { checkEvaluateScoreLevel, checkExpectLevel, EVALUATE_WEIGHT_NORMAL, getEvaluateWeight } from "./evaluateConfig";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import SpinerSubmit from "../../components/SpinerSubmit";

import { createBehaviorRows, shouldUseOldBehaviorRows } from "./shared/behaviorTemplate";
import { computeWeightedSum, computeBehaviorSum, toFullScore } from "./shared/scoreUtils";
import { saveBehaviorArray, saveDevelopmentArray } from "./shared/saveEvaluateArrays";
import { isFilledObjectArrayEdit, hasScoreOrderErrorEdit, submitErrorMessage } from "./shared/validators";
import { useApproveUserFlow } from "./shared/useApproveUserFlow";
import DevelopmentTopicSelect from "./components/DevelopmentTopicSelect";
import ApproveFlowCard from "./components/ApproveFlowCard";
import EvaLuateFormAlert from "./components/EvaLuateFormAlert";

const API_URL = process.env.REACT_APP_API_CORS;

function EditEvaluateForm(props) {
  const {
    user_id,//user_id เจ้าของใบประเมิน
    evaluate_salary_id,
    budget_year,
    round,
    onButtonClick,
    approve_user_id,
    status,
    version,
    evaluate_salary_approve_id,
    approve_user,
    checkBack = 0,
    conditon_for_admin,
    evaluate_status
  } = props;
  // ใบประเมินปี 2569 รอบ 1 และปีก่อนหน้า ใช้สมรรถนะชุดเก่า
  const useOldBehaviorRows = shouldUseOldBehaviorRows(budget_year, round);
  const baseURL = process.env.REACT_APP_API_CORS;
  const user = GetCookieData("userData")
  const userPosition = GetCookieData("userPosition");
  const [passedSteps, setPassedSteps] = useState([1]);
  const [activeTab, setactiveTab] = useState(1);
  const [EditGroup, setEditGroup] = useState(null);
  const [evaluateResultID, setEvaluateResultID] = useState(null);
  const [evaluateDataBehavior, setEvaluateDataBehavior] = useState([]);
  const [evaluateBehaviorLoaded, setEvaluateBehaviorLoaded] = useState(false);
  // โหลดคะแนนพฤติกรรม (tab 2) ไม่สำเร็จ -> formTwoData จะค้างเป็นแถวเปล่า (score "")
  // ทำให้ calculatedValuesForm2 = 0 แล้วทุก path ที่บันทึกจะเขียน second_score = 0
  // ทับคะแนนจริงใน DB จึงต้องบล็อกการบันทึกไว้ทั้งหมด
  const [behaviorLoadFailed, setBehaviorLoadFailed] = useState(false);
  const [evaluateDataDevelopment, setEvaluateDataDevelopment] = useState([]);
  const [approveInfo, setApproveInfo] = useState([]);
  const [totalWeight, setTotalWeight] = useState(0);
  const [alretFormOne, setAlretFormOne] = useState(false);
  const [alretWeight, setAlretWeight] = useState(false);
  const [alretFormFour, setAlretFormFour] = useState(false);
  const [countSumWeight, setCountSumWeight] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileUploads, setFileUploads] = useState(Array.from({ length: 5 }, () => null));
  const [task, setTask] = useState("")
  const [confirmModal, setconfirmModal] = useState(false)
  const [indexArrGrooup, setIndexArrGrooup] = useState([])

  const [groups, setGroups] = useState([
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: "", evaluate_salary_result_id: "", file_data: "" },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: "", evaluate_salary_result_id: "", file_data: "" },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: "", evaluate_salary_result_id: "", file_data: "" },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: "", evaluate_salary_result_id: "", file_data: "" },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: "", evaluate_salary_result_id: "", file_data: "" },
  ]);

  const [checkDiffFormTwoData, setCheckDiffFormTwoData] = useState(createBehaviorRows(true, null, useOldBehaviorRows));
  const [formTwoData, setFormTwoData] = useState(createBehaviorRows(true, null, useOldBehaviorRows));

  const [formTheeData_1, setFormTheeData_1] = useState({
    label: "องค์ประกอบที่ 1 : ผลสัมฤทธิ์ของงาน",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.first,
  });

  const [formTheeData_2, setFormTheeData_2] = useState({
    label: "องค์ประกอบที่ 2 : พฤติกรรมการปฏิบัติราชการ(สมรรถนะ)",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.second,
  });

  const [formFourData, setFormFourData] = useState([
    { id: 1, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 2, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 3, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 4, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 5, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
  ]);

  const [checkDiffFormFourData, setCheckDiffFormFourData] = useState([
    { id: 1, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 2, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 3, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 4, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
    { id: 5, topic: "", description: "", evaluate_salary_development_id: "", step_active: "" },
  ]);

  const [calculatedValues, setCalculatedValues] = useState([]);
  const [calculatedValuesForm2, setCalculatedValuesForm2] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [link, setLink] = useState(null);

  // น้ำหนักองค์ประกอบ: ปกติ 70/30 แต่ถ้า "ยังไม่ผ่านการทดลองงาน" (user_trial = 1) ใช้ 50/50
  useEffect(() => {
    const weight = getEvaluateWeight(dataInfo);
    setFormTheeData_1(prevData => ({ ...prevData, percentage: weight.first }));
    setFormTheeData_2(prevData => ({ ...prevData, percentage: weight.second }));
  }, [dataInfo?.user_trial]);

  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const filterSubAdmin = userData?.positionSubAdmin?.map(i => i.type_sub_admin);

  // ---- ลำดับผู้อนุมัติ (เดิมเป็น state+handler ~120 บรรทัด ย้ายไป shared hook) ----
  const {
    approveUserFlow,
    flowLoading,
    nextLvApproveName,
    handleChangeUser,
    handleAddUserFlow,
    handleRemoveUserFlow,
    handleEditFlow,
    resetFlow,
  } = useApproveUserFlow({
    evaluate_salary_id,
    budget_year,
    round,
    token,
    autoStart: false,
    initialValue: null,
  });

  const handleDevelopmentChange = (id, field, value) => {
    setFormFourData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const toggleTab = tab => {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  };

  const handleAddGroup = () => {
    setGroups(prevGroups => [
      ...prevGroups,
      {
        indicator: "",
        scores: ["", "", "", "", ""],
        score: "",
        weight: "",
        no: prevGroups?.length + 1,
        evaluate_salary_result_id: "",
        file_data: "",
        step_status: "",
        step_active: "",
      },
    ]);

    setEditGroup(prevGroups2 => [
      ...(prevGroups2 || []),
      { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: prevGroups2?.length + 1, file_data: "", step_status: "", step_active: "" },
    ]);
  };

  const handleInputChange = (groupIndex, key, value) => {
    setGroups(prevGroups => {
      const updatedGroups = [...prevGroups];
      const groupToUpdate = updatedGroups[groupIndex];
      groupToUpdate[key] = value;
      updatedGroups[groupIndex] = groupToUpdate;
      return updatedGroups;
    });
    setEditGroup(prevGroups => {
      const updatedGroups = [...prevGroups];
      const groupToUpdate = updatedGroups[groupIndex];
      groupToUpdate[key] = value;
      updatedGroups[groupIndex] = groupToUpdate;
      return updatedGroups;
    });
  };

  useEffect(() => {
    const sum = computeWeightedSum(EditGroup !== null ? EditGroup : groups);
    setCalculatedValues(sum);
    setFormTheeData_1(prevData => ({
      ...prevData,
      score: toFullScore(sum),
    }));
  }, [groups]);

  useEffect(() => {
    const sum = computeBehaviorSum(formTwoData);
    setCalculatedValuesForm2(sum);
    setFormTheeData_2(prevData => ({
      ...prevData,
      score: toFullScore(sum),
    }));
  }, [formTwoData]);

  const handleScoreChange = (groupIndex, scoreIndex, value) => {
    setIndexArrGrooup((prev => [...prev.filter(x => x !== scoreIndex), scoreIndex]))
    setGroups(prevGroups => {
      const newGroups = [...prevGroups];
      newGroups[groupIndex].scores[scoreIndex] = value;
      return newGroups;
    });
    setEditGroup(prevGroups => {
      const newGroups = [...prevGroups];
      newGroups[groupIndex].scores[scoreIndex] = value;
      return newGroups;
    });
  };

  const handleRemoveGroup = groupIndex => {
    const reOrderNo = (arr) =>
      arr.map((item, index) => ({
        ...item,
        no: index + 1
      }));

    setGroups(prevGroups =>
      reOrderNo(prevGroups.filter((group, index) => index !== groupIndex))
    );
    setEditGroup(prevGroups =>
      reOrderNo(prevGroups.filter((group, index) => index !== groupIndex))
    );
  };

  const handleDeleteFormOne = async evaluate_salary_result_id => {
    try {
      await axios.delete(
        `${API_URL}/api/evaluateSalaryResult/${evaluate_salary_result_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  let valScore =
    (Number(formTheeData_2.score) * Number(formTheeData_2.percentage)) / 100 +
    (Number(formTheeData_1.score) * Number(formTheeData_1.percentage)) / 100;

  // แปลงคะแนนให้ปลอดภัยจาก NaN เสมอ
const toScore = (val, multiply = true) => {
  if (val === undefined || val === null || val === '' || (Array.isArray(val) && val.length === 0)) {
    return "0.0000";
  }
  const num = multiply ? Number(val) * (100 / 5) : Number(val);
  return Number.isFinite(num) ? num.toFixed(4) : "0.0000";
};

// กันทุกทางที่ยิง PUT/POST คะแนน ไม่ให้บันทึกตอนที่คะแนนพฤติกรรมโหลดไม่สำเร็จ
// เพราะ calculatedValuesForm2 จะเป็น "0.0000" จากแถวเปล่า แล้วทับของจริงใน DB
const blockSaveIfBehaviorMissing = () => {
  if (!behaviorLoadFailed) return false;
  setSubmitError(submitErrorMessage.behaviorLoadFailed);
  return true;
};

const submitEvaluate = async (task) => {
  if (user_id === user?.user_id) {
    const url = "/api/evaluateSalaryHistory/save";
    let dataHistory = {
      evaluate_salary_id: evaluate_salary_id,
      seq: 8,
      first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
      second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
      total_score: formTheeData_1.score !== "" && formTheeData_2.score !== "" ? valScore.toFixed(4) : "0.0000",
      version: Number(version) + 1,
    };
    await FetchAxiosPost(url, dataHistory, token)
  }
  // if (Number(checkBack) !== 1 && Acceptedevaluate_salary_result_id.length > 0) {
    // Acceptedevaluate_salary_result_id.forEach((x) => handleDeleteFormOne(x));
    // EditGroup.forEach((y, idx) => { y.no = idx + 1; });
    await allEditSandBack();
  // }

  const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
  const firstScore = toScore(calculatedValues);
  const secondScore = toScore(calculatedValuesForm2);

  const baseData = {
    user_id,
    budget_year,
    first_score: firstScore,
    second_score: secondScore,
    total_score: valScore,
    show_score: valScore,
  };

  if (Number(status) === 4) {
    // allEditSandBack();
    await FetchAxiosPut(url_submit, {
      ...baseData,
      status: 2,
      evaluate_url_ref: link,
      check_sendback: 0,
    }, token);
  } else if (Number(status) === 1) {
    await FetchAxiosPut(url_submit, { ...baseData, status: 4 }, token);
    await FetchAxiosPut(url_submit, { ...baseData, status: 2, evaluate_url_ref: link }, token);
  } else if (Number(status) === 5) {
    await FetchAxiosPut(url_submit, { ...baseData, status: 2, evaluate_url_ref: link }, token);
  } else {
    await FetchAxiosPut(url_submit, { ...baseData, evaluate_url_ref: link }, token);
  }

  if (evaluate_salary_approve_id !== undefined) {
    const urlApprovMyself = `/api/evaluateSalaryApprove/${evaluate_salary_approve_id}`;
    await FetchAxiosPut(urlApprovMyself, {
      evaluate_salary_id,
      user_id,
      budget_year,
      sendback_status: 1,
    }, token);
  }

  if (task === "admin" || task === "normal") {
    onButtonClick(task);
  }
};

// กันกดปุ่ม "ส่งแบบประเมิน" ซ้ำระหว่างที่ยังส่งไม่เสร็จ
const handleSubmit = async (task) => {
  if (blockSaveIfBehaviorMissing()) return;
  if (isSubmittingRef.current) return;
  isSubmittingRef.current = true;
  setIsSubmitting(true);
  try {
    await submitEvaluate(task);
  } catch (error) {
    console.error(error);
    isSubmittingRef.current = false;
    setIsSubmitting(false);
    throw error;
  }
};

  const allEditDraftFuction = async () => {
          const indicatorArray = EditGroup.map((item) => {
            const hasNewFile = !!fileUploads[item.no];
            return {
                no: item.no,
                indicator: item.indicator,
                score_1: item.scores?.[0],
                score_2: item.scores?.[1],
                score_3: item.scores?.[2],
                score_4: item.scores?.[3],
                score_5: item.scores?.[4],
                score: item.score,
                weight: item.weight,
                file_data: hasNewFile ? undefined : (item.file_data ?? ''),
            }
          });
        
          let payload = {
            evaluate_salary_id: evaluate_salary_id,
            user_id: user_id,
            budget_year: budget_year,
            round: round,
            indicatorArray: indicatorArray,
          };
        
          const urlResult = `/api/evaluateSalaryResult/array/save`;
          let data = JSON.stringify(payload);

          let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: baseURL + urlResult,
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
              },
              data: data
          };

          try {
            const response = await axios.request(config);
            let result = response?.data?.results ?? [];

            if (result?.length > 0) {
              for (const i of result) {
                if (i.success && i.no && i.insertedId) {
                  const file = fileUploads[i.no];

                  if (file) {
                    const url_file = `/api/evaluateSalaryResult/file/${i.insertedId}`;
                    await FetchAxiosFile(url_file, token, file);
                  }
                }
              }
            }
          } catch (error) {
            console.log("Save evaluateSalaryResult error:", error);
            throw error;
          }
    // บันทึกพฤติกรรม/แผนพัฒนาเป็นชุดเดียวแบบเดียวกับ evaluateSalaryResult
    // เดิมใช้ .map(async ...) โดยไม่ await (ยิงลอยไปเฉยๆ) และ PUT ทับ record เดิมด้วย
    // step_active ที่คำนวณฝั่ง client ทำให้ข้อมูลผิดเวอร์ชัน/ซ้ำ
    // ตอนนี้ส่งสถานะปัจจุบันของฟอร์มทั้งชุดไปให้ server สร้างเวอร์ชันใหม่ให้เอง
    // หัวข้อที่ถูกล้าง (topic = "0" หรือว่าง) จะถูกบันทึกเป็นแถวว่างของเวอร์ชันใหม่
    // แทนการ hack step_active = 0 แบบเดิม
    await saveBehaviorArray(
      { evaluate_salary_id, user_id, budget_year, round, rows: formTwoData },
      token
    );

    await saveDevelopmentArray(
      { evaluate_salary_id, user_id, budget_year, round, rows: formFourData },
      token
    );
  };

  const [isUpdate, setIsUpdate] = useState(false)
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isSubmittingRef = useRef(false)
  const handleDraft = async (isDraftApprove = false) => {
  if (blockSaveIfBehaviorMissing()) return;
  setIsUpdateSuccess(null);
  try {
    setIsUpdate(true);

    const hasBothScores = formTheeData_1.score !== "" && formTheeData_2.score !== "";
    const show_score = hasBothScores
                                        ? isNaN(valScore.toFixed(4)) ? "0.0000" : valScore.toFixed(4)
                                        : "0.0000"

    if (Acceptedevaluate_salary_result_id.length > 0) {
      Acceptedevaluate_salary_result_id.forEach((x) => handleDeleteFormOne(x));
      EditGroup.forEach((y, idx) => { y.no = idx + 1; });
    }

   await allEditDraftFuction();

    const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
    let data = {
      user_id: user_id,
      budget_year: budget_year,
      status: isDraftApprove ? 2 : 1,
      evaluate_url_ref: link,
      first_score: toScore(calculatedValues),
      second_score: formTheeData_2.score !== "" ? toScore(calculatedValuesForm2) : "0.0000",
      total_score: show_score,
      show_score: show_score,
    };

    if (isDraftApprove) {
      data.approve_draft = "1";
    }

    await FetchAxiosPut(url_submit, data, token);
    setIsUpdate(false);
    setIsUpdateSuccess(true);
    !isDraftApprove && onButtonClick('normal');
  } catch (error) {
    setIsUpdate(false);
    setIsUpdateSuccess(false);
  }
};

  const allEditSandBack = async () => {
    try {
      const edit_group = groups?.filter(x => x.evaluate_salary_result_id)
        if (edit_group) {
          const indicatorArray = EditGroup.filter((item) => item.weight).map((item) => {
            const hasNewFile = !!fileUploads[item.no];
            return {
                no: item.no,
                indicator: item.indicator,
                score_1: item.scores?.[0],
                score_2: item.scores?.[1],
                score_3: item.scores?.[2],
                score_4: item.scores?.[3],
                score_5: item.scores?.[4],
                score: item.score,
                weight: item.weight,
                file_data: hasNewFile ? undefined : (item.file_data ?? ''),
            }
          });
        
          let payload = {
            evaluate_salary_id: evaluate_salary_id,
            user_id: user_id,
            budget_year: budget_year,
            round: round,
            indicatorArray: indicatorArray,
          };
        
          const urlResult = `/api/evaluateSalaryResult/array/save`;
          let data = JSON.stringify(payload);
        
          let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: baseURL + urlResult,
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
              },
              data: data
          };
        
          await axios.request(config)
              .then(async (response) => {
                let result = response?.data?.results ?? []
              
                if (result?.length > 0) {
                  for (const i of result) {
                    if (i.success && i.no && i.insertedId) {
                      const file = fileUploads[i.no];
                    
                      if (file) {
                        const url_file = `/api/evaluateSalaryResult/file/${i.insertedId}`;
                        await FetchAxiosFile(url_file, token, file);
                      }
                    }
                  }
                }
          })
          .catch((error) => {
            console.log(error);
          });
      }

      // ส่งสถานะปัจจุบันของฟอร์มทั้งชุดไปให้ server สร้างเวอร์ชันใหม่ในคำขอเดียว
      // เดิมเช็ค `if (behaviorChange)` ซึ่งเป็น array จึงเป็น true เสมอ แล้ว loop แบบไม่ await
      // สลับไปมาระหว่าง POST (สร้างเวอร์ชันใหม่) กับ PUT (ทับของเดิม) ตาม match_data
      // และยัง fallback ค่าไปหา originalData ทำให้บางแถวถูกบันทึกด้วยค่าเก่า
      await saveBehaviorArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formTwoData },
        token
      );

      await saveDevelopmentArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formFourData },
        token
      );
    } catch (error) {
      console.log(error.response?.data?.message ?? error.message);
    }
  };

  const handleSendBackUser = async (evaluate_salary_id, user_id, approve_userId, approveUer) => {
    if (blockSaveIfBehaviorMissing()) return;
    // ต้อง await ให้บันทึกฟอร์มเสร็จก่อน ไม่งั้น onButtonClick ด้านล่างจะพาออกจากหน้า
    // ตั้งแต่ request ยังไม่ถึง server ทำให้ข้อมูลบางส่วนหาย
    await allEditSandBack()
    const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
    let data = {
      user_id: user_id,
      budget_year: budget_year,
      status: 4,
      evaluate_url_ref: link,
      version: Number(version) + 1,
      first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
      second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
      total_score: formTheeData_1.score !== "" && formTheeData_2.score !== "" ? valScore.toFixed(4) : "0.0000",
      approve_user_id: user_id,
      check_sendback: 1,
    };
    await FetchAxiosPut(url_submit, data, token);

    const urlApprovMyself = `/api/evaluateSalaryApprove/${evaluate_salary_approve_id}`;
    let dataApprovMyself = {
      sendback_status: "0",
      evaluate_salary_id: evaluate_salary_id,
      user_id: user_id,
      budget_year: budget_year,
    };

    await FetchAxiosPut(urlApprovMyself, dataApprovMyself, token);

    onButtonClick('normal');
  }

  const handleSendBack = async (evaluatesalaryid, evaluatesalaryapprove_id, user_id, approve_userId, approveUer) => {
    if (blockSaveIfBehaviorMissing()) return;
    // ต้อง await ให้บันทึกฟอร์มเสร็จก่อน ไม่งั้น onButtonClick ด้านล่างจะพาออกจากหน้า
    // ตั้งแต่ request ยังไม่ถึง server ทำให้ข้อมูลบางส่วนหาย
    await allEditSandBack()
    const url = "/api/evaluateSalaryHistory/save";
    let dataSendback = {
      evaluate_salary_id: evaluatesalaryid,
      seq: 10,
      first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
      second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
      total_score: formTheeData_1.score !== "" && formTheeData_2.score !== "" ? valScore.toFixed(4) : "0.0000",
      approve_user_id: approve_user_id,
      approve_user: approve_user,
      version: Number(version) + 1,
      send_back_user_id: approve_userId,
      send_back_user: approveUer
    };
    await FetchAxiosPost(url, dataSendback, token)

    const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
    let data = {
      user_id: user_id,
      budget_year: budget_year,
      status: 4,
      version: Number(version) + 1,
      first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
      second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
      total_score: formTheeData_1.score !== "" && formTheeData_2.score !== "" ? valScore.toFixed(4) : "0.0000",
      show_score: formTheeData_1.score !== "" && formTheeData_2.score !== "" ? valScore.toFixed(4) : "0.0000",
      evaluate_url_ref: link,
    };
    await FetchAxiosPut(url_submit, data, token);

    const urlApprov = `/api/evaluateSalaryApprove/${evaluatesalaryapprove_id}`;
    let dataApprov = {
      approve_status: 2,
      evaluate_salary_id: evaluatesalaryid,
      user_id: user_id,
      budget_year: budget_year,
    };

    await FetchAxiosPut(urlApprov, dataApprov, token);

    const urlApprovMyself = `/api/evaluateSalaryApprove/${evaluate_salary_approve_id}`;
    let dataApprovMyself = {
      sendback_status: "0",
      evaluate_salary_id: evaluate_salary_id,
      user_id: user_id,
      budget_year: budget_year,
    };

    await FetchAxiosPut(urlApprovMyself, dataApprovMyself, token);

    onButtonClick('normal');
  };

  const handleButtonFileClick = (no) => {
    const fileInput = document.getElementById(`file-input-${no}`);
    fileInput?.click();
  };

  const handleFileChange = (e, no) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if (file.size > 1024 * 1024) {
      alert("ไฟล์ต้องมีขนาดไม่เกิน 1 MB");
      return;
    }
  
    setFileUploads((prev) => ({
      ...prev,
      [no]: file,
    }));
  };

  const handleRemoveFile = (no) => {
    setFileUploads((prev) => {
      const updated = { ...prev };
      delete updated[no];
      return updated;
    });
  
    const fileInput = document.getElementById(`file-input-${no}`);
    if (fileInput) fileInput.value = "";
  };

  // const handleClearFile = groupIndex => {
  //   const fileInput = document.getElementById(`file-input-${groupIndex}`);
  //   if (fileInput) {
  //     fileInput.value = null;
  //     const newFileUploads = [...fileUploads];
  //     newFileUploads[groupIndex] = null;
  //     setFileUploads(newFileUploads);
  //   }
  // };

  useEffect(() => {
    const url = `${API_URL}/api/users/${user_id}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios.get(url, config).then(response => {
      setDataInfo(response.data.result);
    }).catch(error => {
      console.error(error);
    });
  }, []);

  const fetchEvaluateResult = async () => {
    const url = `${API_URL}/api/evaluateSalaryResult/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "evaluate_salary_result_id",
      "order[1]": "DESC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
    });

    const config = { headers: { Authorization: `Bearer ${token}` }, params };

    await axios.get(url, config).then(response => {
      const result = response.data.result;
      let maxStep = -Infinity;
      for (const r of result) {
        if (r.step_active > maxStep) {
          maxStep = r.step_active;
        }
      }
      const newData = result.filter(r => r.step_active === maxStep);

      const formattedData = newData.map(item => {
        const { indicator, score, weight, no, evaluate_salary_result_id, file_data, step_active, step_status } = item;
        return {
          indicator,
          scores: [item.score_1, item.score_2, item.score_3, item.score_4, item.score_5],
          score: score ? score.toFixed(2) : "",
          weight,
          no,
          evaluate_salary_result_id,
          file_data,
          step_active,
          step_status,
        };
      });

      if (formattedData.length !== 0) {
        if (formattedData.length > 5) {
          for (let index = 5; index < formattedData.length; index++) {
            handleAddGroup();
          }
        }
        setEditGroup(formattedData);

        const calculatedValues = formattedData.map((group, index) => (group.weight * group.score) / 100);
        const sum = calculatedValues.reduce((accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1, 0);

        setCalculatedValues(sum);
        setFormTheeData_1(prevData => ({ ...prevData, score: toFullScore(sum) }));
      }

      setEvaluateResultID(response.data.result.map(i => i.evaluate_salary_result_id));
    }).catch(error => console.error("Error:", error));
  };

  const fetchEvaluateBehavior = async () => {
    const url = `${API_URL}/api/evaluateSalaryBehavior/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "evaluate_salary_behavior_id",
      "order[1]": "DESC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
    });

    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      // เก็บผลดิบไว้ก่อนเฉยๆ ให้ useEffect ที่รอ dataInfo.user_category_id
      // (ด้านล่าง) เป็นคนสร้าง formTwoData/checkDiffFormTwoData ด้วยชุดแถว
      // ที่ถูกต้องตามสมรรถนะ (BASE_ROWS หรือ EXPERT_ROWS) แล้ว merge คะแนนเดิมเข้าไป
      setEvaluateDataBehavior(response.data.result);
      setBehaviorLoadFailed(false);
    } catch (error) {
      // เดิม .catch() แค่ console.error แล้วปล่อยผ่าน ทำให้ evaluateBehaviorLoaded
      // ค้างเป็น false, formTwoData ค้างเป็นแถวเปล่า และผู้ใช้ยังกดบันทึกได้
      // ผลคือ second_score ถูกคำนวณเป็น 0 แล้วเขียนทับคะแนนจริงใน DB
      console.error("Error:", error);
      setBehaviorLoadFailed(true);
    } finally {
      // ต้องตั้งเป็น true เสมอเพื่อบอกว่า "โหลดจบแล้ว" (สำเร็จหรือไม่ก็ตาม)
      // สถานะสำเร็จ/ล้มเหลวดูจาก behaviorLoadFailed แทน
      setEvaluateBehaviorLoaded(true);
    }
  };

  const fetchEvaluateDevelopment = async () => {
    const url = `${API_URL}/api/evaluateSalaryDevelopment/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "evaluate_salary_development_id",
      "order[1]": "DESC",
      "filter[budget_year][0]": budget_year,
      "filter[round][0]": round,
      "filter[evaluate_salary_id][0]": evaluate_salary_id,
      "filter[user_id][0]": user_id,
    });

    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    await axios.get(url, config).then(response => {
      setFormFourData(prevFormTwoData =>
        prevFormTwoData.map(formItem => {
          const matchingEvaluateData = response.data.result.find(evalItem => evalItem.no === formItem.id);
          return {
            ...formItem,
            topic: matchingEvaluateData ? matchingEvaluateData.development_type_id : "",
            description: matchingEvaluateData ? matchingEvaluateData.development : "",
            evaluate_salary_development_id: matchingEvaluateData ? matchingEvaluateData.evaluate_salary_development_id : "",
            step_active: matchingEvaluateData ? matchingEvaluateData.step_active : "",
            step_status: matchingEvaluateData ? matchingEvaluateData.step_status : "",
          };
        })
      );

      setCheckDiffFormFourData(prevFormTwoData =>
        prevFormTwoData.map(formItem => {
          const matchingEvaluateData = response.data.result.find(evalItem => evalItem.no === formItem.no);
          return {
            ...formItem,
            topic: matchingEvaluateData ? matchingEvaluateData.score : "",
            evaluate_salary_development_id: matchingEvaluateData ? matchingEvaluateData.evaluate_salary_development_id : "",
            step_active: matchingEvaluateData ? matchingEvaluateData.step_active : "",
            step_status: matchingEvaluateData ? matchingEvaluateData.step_status : "",
          };
        })
      );

      setEvaluateDataDevelopment(response.data.result);
    }).catch(error => console.error("Error:", error));
  };

  const [evaluateData, setEvaluateData] = useState([])
  const fetchdatatableApprove = async (evaluate_salary_id) => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = { headers: { Authorization: `Bearer ${token}` } };
    axios.get(urlCheckRound, config).then(async response => {
      const url = `${API_URL}/api/evaluateSalaryApprove/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "evaluate_salary_approve_id",
        "order[1]": "DESC",
        "filter[budget_year][0]": response.data.result.this_budget_year,
        "filter[round][0]": response.data.result.this_round,
        "filter[evaluate_salary_id][0]": evaluate_salary_id,
      });
      const config = { headers: { Authorization: `Bearer ${token}` }, params };
      await axios.get(url, config).then(response => {
        const maxVersion = Math.max(...response.data.result.map(item => item.version));
        const filteredData = response.data.result.filter(item => item.version === maxVersion);
        // console.log(filteredData);
        setEvaluateData(filteredData)
      }).catch((error) => console.error("Error:", error));
    });
  };

  const [evaluateDataUser, setEvaluateDataUser] = useState([])
  const fetchdatatableUser = async () => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = { headers: { Authorization: `Bearer ${token}` } };
    await axios.get(urlCheckRound, config).then(response => {
      const url = `${API_URL}/api/evaluateSalary/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "user_id",
        "order[1]": "DESC",
        "filter[budget_year][0]": response.data.result.this_budget_year,
        "filter[round][0]": response.data.result.this_round,
        "filter[user_id][0]": user_id,
      });
      const config = { headers: { Authorization: `Bearer ${token}` }, params };
      axios.get(url, config).then(response => {
        // console.log(response.data.result);
        
        setEvaluateDataUser(response.data.result);
      }).catch((error) => console.error("Error:", error));
    });
  };

  useEffect(() => {
    const letEffect = async () => {
      setLoading(true)
      await fetchdatatableUser();
      await fetchdatatableApprove(evaluate_salary_id);
      await fetchEvaluateResult();
      await fetchEvaluateBehavior();
      await fetchEvaluateDevelopment();
      setTimeout(() => {
        setLoading(false)
      }, 2500);
    }
    letEffect()
  }, []);

  // สร้าง/รวมข้อมูลตาราง "พฤติกรรมการปฏิบัติราชการ" ใหม่ ก็ต่อเมื่อรู้ user_level_id
  // แน่ชัดแล้ว (dataInfo โหลดเสร็จ) และคะแนนเดิมจาก API โหลดเสร็จแล้วด้วย (evaluateBehaviorLoaded)
  // เพื่อให้ได้ชุดแถว (BASE_ROWS/EXPERT_ROWS) ที่ถูกต้องตามสมรรถนะของ user คนนี้จริงๆ
  useEffect(() => {
    console.log(dataInfo);
    
    if (!evaluateBehaviorLoaded) return;

    const rebuiltFormTwoData = createBehaviorRows(true, dataInfo.user_level_id, useOldBehaviorRows).map(row => {
      const matched = evaluateDataBehavior.find(evalItem => evalItem.no === row.no);
      return {
        ...row,
        score:
          matched && matched.score !== null && matched.score !== undefined
            ? matched.score.toFixed(2)
            : "",
        evaluate_salary_behavior_id: matched ? matched.evaluate_salary_behavior_id : "",
        step_active: matched ? matched.step_active : "",
        step_status: matched ? matched.step_status : "",
      };
    });

    const rebuiltCheckDiff = createBehaviorRows(true, dataInfo.user_level_id, useOldBehaviorRows).map(row => {
      const matched = evaluateDataBehavior.find(evalItem => evalItem.no === row.no);
      return {
        ...row,
        score: matched ? matched.score : "",
        evaluate_salary_behavior_id: matched ? matched.evaluate_salary_behavior_id : "",
        step_active: matched ? matched.step_active : "",
        step_status: matched ? matched.step_status : "",
      };
    });

    setFormTwoData(rebuiltFormTwoData);
    setCheckDiffFormTwoData(rebuiltCheckDiff);
  }, [dataInfo?.user_level_id, evaluateBehaviorLoaded, evaluateDataBehavior]);

  useEffect(() => {
    if (approve_user_id !== null && approve_user_id !== undefined) {
      const url = `${API_URL}/api/users/${approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios.get(url, config).then(response => {
        setApproveInfo(response.data.result);
      }).catch(error => {
        console.error(error);
      });
    }
  }, []);

  useEffect(() => {
    let sum = 0;
    groups.forEach(group => {
      sum += parseFloat(Number(group.weight));
    });
    setTotalWeight(sum);
  }, [groups]);

  useEffect(() => {
    let sum = 0;
    if (EditGroup !== null) {
      EditGroup.forEach(group => {
        if (group.weight !== null) {
          sum += parseFloat(Number(group.weight));
        }
      });
    }
    setTotalWeight(sum);
  }, [EditGroup]);

  const isSpacialFlowOrg = (org_id) => { //สำหรับกลุ่มพิเศษใน สลธ (150:กลุ่มช่วยอำนวยการ, 185:กลุ่มสวัสดิการและเครื่องราชอิสริยาภรณ์ม 167;กลุ่มอาคารสถานที่และยานพาหนะ, 44:ฝ่ายสารบรรณ, 37: ตัวมันเอง(สำหรับคนไม่มีกลุ่มแต่อยู่ในสลธ))
    //ให้ข้ามเชี่ยวชาญผู้ที่เข้ามาช่วยดูการประเมินในกลุ่มเล็ก
    if ([150, 185, 167, 44, 37].includes(org_id)) {
      return true
    }
    return false
  }

  const findOrg = async (approve_id) => {
    let leaderName
    const leaderNode = await fetchPositionId(approve_id, true)

    const check_leaderNode = Array.isArray(leaderNode) ?
      leaderNode?.find(item => item.position_id === 3 || item.position_id === 4)
      : (leaderNode?.position_id === 3 || leaderNode?.position_id === 4) && leaderNode

    const response = await axios.get(`${API_URL}/api/orgInner/id/${Array.isArray(leaderNode) ? leaderNode?.find(i => i.status == 1)?.org_id : leaderNode?.org_id}`, { headers: { Authorization: `Bearer ${token}` } });
    const thisOrg = response?.data.result
    const thisNodelv = response?.data.result?.nodelv
    const nextLeaderNode = await fetchPositionId(null, true, thisOrg.org_id)

    if (check_leaderNode || ([851].includes(approve_user_id) && evaluate_status == 2)) {
      return "คณะกรรมการกลั่นกรอง"
    }
    let nextLeaderNodeOnParent
    if (nextLeaderNode.length === 1 && nextLeaderNode[0].position_id !== 2) {
      if (Number(nextLeaderNode[0].user_id) === approve_id) {
        nextLeaderNodeOnParent = await fetchPositionId(null, true, thisOrg.parent_id)
      }
    }

    if (thisNodelv == 1) {
      //* เลขาธิการ ก.พ.ร.
      leaderName = nextLeaderNode?.find(item => item.position_id === 2)
      return leaderName?.user_name
    } else if (thisNodelv == 2) {
      //* รองเลขาธิการ ก.พ.ร. และ ผู้ช่วย
      leaderName = nextLeaderNode?.find(item => item.position_id === 6 && item.user_id != approve_id)
      if (!leaderName?.user_id) leaderName = nextLeaderNode?.find(item => item.position_id === 5 && item.user_id != approve_id)
      if (!leaderName?.user_id) leaderName = nextLeaderNode?.find(item => item.position_id === 4 && item.user_id != approve_id)
      if (!leaderName?.user_id) leaderName = nextLeaderNode?.find(item => item.position_id === 3 && item.user_id != approve_id)
      return leaderName?.user_name
    } else if (thisNodelv == 3) {
      //* ผอ.กอง และ ผู้เชี่ยวชาญ
      leaderName = nextLeaderNode?.find(item => item.position_id === 7)
      if (approve_id == userData.user_id) {
        leaderName = nextLeaderNode?.find(item => item.position_id === 6)
      }
      if (!leaderName) {//ไม่เจอให้ไปหาคนถัดไปใน parent ของกลุ่ม
        leaderName = nextLeaderNodeOnParent?.find(item => item.position_id === 7)
        if (approve_id == userData.user_id) {
          leaderName = nextLeaderNodeOnParent?.find(item => item.position_id === (isSpacialFlowOrg(thisOrg.org_id) ? 5 : 6))
          if (!leaderName) {
            leaderName = nextLeaderNodeOnParent?.find(item => item.position_id === (5))
          }
        }
      }
      return leaderName?.user_name
    }
  }

  const fetchPositionId = async (userid = null, next_org_lv = false, get_org = null) => {
    try {
      const url = `${API_URL}/api/users/position/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "position_id",
        "order[1]": "DESC",
        "filter[user_id][0]": userid,
        "filter[status][0]": 1,
      });
      if (get_org) {
        params.append("filter[org_id][0]", get_org)
      }
      if (!userid) {
        params.delete("filter[user_id][0]", userid)
      }
      const config = { headers: { Authorization: `Bearer ${token}` }, params };

      const response = await axios.get(url, config);

      if (response.data.result.length > 0) {
        const data = response.data.result.find(i => i.is_default);
        if (get_org) {
          return response.data.result
        } else if (next_org_lv) {
          if (data) {
            return data;
          } else if (response.data.result.length == 1) {
            return response.data.result
          }
        } else {
          if (data) {
            return data.position_id;
          } else if (response.data.result.length == 1) {
            return response.data.result.find(i => i.status == 1).position_id;
          }
        }
      } else {
        return 8;
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  useEffect(() => {
    const sourceGroup = EditGroup !== null ? EditGroup : groups;
  
    const isRowComplete = (row) =>
      row.indicator !== "" &&
      Array.isArray(row.scores) &&
      row.scores.length > 0 &&
      row.scores.every((s) => s !== "") &&
      row.score !== "";
  
    // มีแถวไหนก็ตามที่ยังไม่ครบ (ไม่สน weight) ให้ alert
    const hasIncompleteRow = sourceGroup.some((row) => !isRowComplete(row));
    setAlretFormOne(hasIncompleteRow);
  
    if (formFourData.some(i => i.topic || i.description)) {
      setAlretFormFour(false);
    } else {
      setAlretFormFour(true);
    }
  
    if (EditGroup !== null && (Number(totalWeight) + Number(EditGroup?.find(x => x.weight !== "")?.weight || 0)) > 100) {
      setAlretWeight(true);
    } else {
      setAlretWeight(false);
    }
  }, [groups, formFourData, formTwoData, totalWeight, EditGroup]);

  useEffect(() => {
    if (EditGroup !== null) {
      let count = 0;
      EditGroup.filter(x => x?.weight !== "" && x?.weight !== null).map(i => {
        count = Number(i.weight ?? 0) + count
      })
      setCountSumWeight(count)
    }
  }, [EditGroup])

  const [Acceptedevaluate_salary_id, setAcceptedevaluate_salary_id] = useState(null)
  const [Acceptedevaluate_salary_result_id, setAcceptedevaluate_salary_result_id] = useState([])
  const [Accepteduser_id, setAccepteduser_id] = useState(null)
  const [Acceptedevaluate_salary_approve_id, setAcceptedevaluate_salary_approve_id] = useState(null)
  const [Acceptedapprove_user_id, setAcceptedapprove_user_id] = useState(null)
  const [Acceptedapprove_user, setAcceptedapprove_user] = useState(null)
  const [AcceptedgroupIndex, setAcceptedgroupIndex] = useState(null)
  const confrimModalAscept = async (evaluate_salary_id, evaluate_salary_approve_id, user_id, approve_user_id, approve_user) => {
    setconfirmModal(true)
    setAcceptedevaluate_salary_id(evaluate_salary_id)
    setAccepteduser_id(user_id)
    setAcceptedevaluate_salary_approve_id(evaluate_salary_approve_id)
    setAcceptedapprove_user_id(approve_user_id)
    setAcceptedapprove_user(approve_user)
  }
  const confrimModalAsceptUser = async (evaluate_salary_id, user_id, approve_userId, approveUer) => {
    setconfirmModal(true)
    setAcceptedevaluate_salary_id(evaluate_salary_id)
    setAccepteduser_id(user_id)
    setAcceptedapprove_user_id(approve_userId)
    setAcceptedapprove_user(approveUer)
  }
  const confrimModalDelete = async (groupIndex, evaluate_salary_result_id) => {
    setconfirmModal(true)
    setAcceptedevaluate_salary_result_id(prev => [...prev, evaluate_salary_result_id])
    setAcceptedgroupIndex(groupIndex)
  }

  const handleCheck = async () => {
    if (blockSaveIfBehaviorMissing()) return;
    let positionid = null

    const urlCheck = `/api/evaluateSalaryApprove/${evaluate_salary_approve_id}`;
    if (user_id !== null && evaluate_salary_approve_id !== null && evaluate_salary_id !== null && budget_year !== null) {
      let dataapp = {
        approve_status: 1,
        evaluate_salary_id: evaluate_salary_id,
        user_id: user_id,
        budget_year: budget_year,
      };
      await FetchAxiosPut(urlCheck, dataapp, token);

      if (evaluate_status === 4) {
        const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
        let data = {
          user_id: user_id,
          budget_year: budget_year,
          first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(2)}` : "0.0000",
          second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(2)}` : "0.0000",
          total_score: valScore,
          status: 2,
          check_sendback: 0,
        };
        await FetchAxiosPut(url_submit, data, token);
      }
      await fetchStatusCheck(budget_year, user_id, round, evaluate_salary_id)
      if (conditon_for_admin && filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3)) {
        positionid = 9
      } else {
        await fetchPositionId(approve_user_id).then(async (resResult) => {
          const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
          const params = new URLSearchParams({ page: 1, size: 1000, "order[0]": "evaluate_salary_history_id", "order[1]": "ASC", "filter[evaluate_salary_id][0]": evaluate_salary_id });
          const config = { headers: { Authorization: `Bearer ${token}` }, params };
          await axios.get(url, config).then(async response => {
            let bool = true
            const alldataresult = response.data?.result
            if (alldataresult[alldataresult.length - 1].approve_user_id === approve_user_id) {
              if (alldataresult[alldataresult.length - 1].approve_date !== null || alldataresult[alldataresult.length - 1].approve_date !== undefined) {
                bool = false
              }
            }
          })
        })
      }
    }
  };

  const fetchStatusCheck = async (budget_year, user_id, round, evaluate_salary_id) => {
    const url = `${API_URL}/api/evaluateSalary/datatable`;
    const params = new URLSearchParams({ page: 1, size: 10, "order[0]": "evaluate_salary_id", "order[1]": "ASC", "filter[budget_year][0]": budget_year, "filter[round][0]": round, "filter[user_id][0]": user_id });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    await axios.get(url, config).then(response => {
      if (response.data.result.find(i => i.status === 4)) {
        const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
        let data = {
          user_id: user_id,
          budget_year: budget_year,
          status: 2,
          first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(2)}` : "0.0000",
          second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(2)}` : "0.0000",
          total_score: valScore,
        };
        FetchAxiosPut(url_submit, data, token);
      }
    }).catch(error => console.error("Error:", error));
  }

  const isFilledObjectArray = isFilledObjectArrayEdit;
  const hasScoreOrderError = () => hasScoreOrderErrorEdit(EditGroup);

  // เงื่อนไขว่าการ์ดลำดับผู้อนุมัติควรเป็นแบบแก้ไขได้หรืออ่านอย่างเดียว (ของเดิม)
  const approveFlowEditable =
    (status === '1' || status === '4') &&
    (user_id === user.user_id ||
      (CheckSubAdmin(user?.positionSubAdmin).length > 0 &&
        (CheckSubAdmin(user?.positionSubAdmin).includes(0) || CheckSubAdmin(user?.positionSubAdmin).includes(3))));

  const nextButtonDisable = (totalWeight < 100 || activeTab === 4 || (EditGroup && Number(countSumWeight) > 100) || EditGroup?.find(x => x?.weight == "") ||
    !isFilledObjectArray(EditGroup) || !(approveUserFlow?.find(x => x?.assessor === 0)) || hasScoreOrderError()
  );

  // ฟังก์ชันสลับตำแหน่งระหว่าง index ปัจจุบัน กับ index ข้างๆ (ขึ้น/ลง)
  const handleSwapNo = (currentIndex, direction) => {
  const targetIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;

  if (targetIndex < 0 || targetIndex >= EditGroup.length) return;

  // เก็บ no เดิมของทั้งสองตัวไว้ก่อน เพื่อไปสลับ fileUploads ให้ตรงกัน
  const currentNo = EditGroup[currentIndex]?.no;
  const targetNo = EditGroup[targetIndex]?.no;

  setEditGroup((prev) => {
    const updated = [...prev];

    [updated[currentIndex], updated[targetIndex]] = [
      updated[targetIndex],
      updated[currentIndex],
    ];

    return updated.map((item, idx) => ({
      ...item,
      no: idx + 1,
    }));
  });

  // สลับไฟล์ที่แนบใหม่ (ถ้ามี) ให้ตามไปกับ item ที่ย้ายตำแหน่งด้วย
  setFileUploads((prev) => {
    const updated = { ...prev };
    const currentFile = updated[currentNo];
    const targetFile = updated[targetNo];

    if (targetFile) {
      updated[currentNo] = targetFile;
    } else {
      delete updated[currentNo];
    }

    if (currentFile) {
      updated[targetNo] = currentFile;
    } else {
      delete updated[targetNo];
    }

    return updated;
  });
};

const [submitError, setSubmitError] = useState(null);
const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

const validateAllTabs = () => {
  const isRowComplete = (row) =>
    row.indicator !== "" &&
    Array.isArray(row.scores) &&
    row.scores.length > 0 &&
    row.scores.every((s) => s !== "") &&
    row.score !== "" && row.weight !== "";

  const sourceGroup = EditGroup !== null ? EditGroup : groups;

  // เช็คก่อนทุกข้อ: ถ้าคะแนน tab 2 โหลดไม่มา ค่าที่เห็นบนฟอร์มไม่ใช่ของจริง
  // จะไปเช็คความครบถ้วนข้ออื่นต่อไม่ได้
  if (behaviorLoadFailed) {
    return { tab: 2, message: submitErrorMessage.behaviorLoadFailed };
  }
  if (sourceGroup.some((row) => !isRowComplete(row))) {
    return { tab: 1, message: submitErrorMessage.evaluateResultCompletely };
  }
  if (Number(countSumWeight) !== 100) {
    return { tab: 1, message: submitErrorMessage.evaluateResultPercentage };
  }
  if (hasScoreOrderError()) {
    return { tab: 1, message: submitErrorMessage.targetLevalScoresOrder };
  }
  if (formTwoData.some((i) => i.score === "" || i.score === null || i.score === undefined)) {
    return { tab: 2, message: submitErrorMessage.evaluateBehaviorCompletely };
  }
  if (alretFormFour) {
    return { tab: 4, message: submitErrorMessage.evaluateDevelopmentCompletely };
  }

  return null;
};

const handleClickSubmit = () => {
  setHasAttemptedSubmit(true);
  const error = validateAllTabs();

  if (error) {
    setPassedSteps((prev) => Array.from(new Set([...prev, error.tab])));
    setactiveTab(error.tab);
    setSubmitError(error.message);
    return;
  }

  setSubmitError(null);
  setTask("SUBMIT");
  setconfirmModal(true);
};

useEffect(() => {
  if (!hasAttemptedSubmit) return;

  const error = validateAllTabs();
  setSubmitError(error ? error.message : null);
}, [EditGroup, groups, countSumWeight, formTwoData, alretFormFour, hasAttemptedSubmit, behaviorLoadFailed]);

  return (
    <Container fluid>
      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong style={{ whiteSpace: "nowrap" }}>ผู้รับการประเมิน :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> ตำแหน่ง :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_position_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> สังกัด :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>
                    {dataInfo.cont_to !== undefined ? (
                      <>{dataInfo.cont_to[0]?.org_name}</>
                    ) : (
                      ""
                    )}
                  </strong>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg={6}>
          <ApproveFlowCard
            flowLoading={flowLoading}
            approveUserFlow={approveUserFlow}
            editable={approveFlowEditable}
            onChangeUser={handleChangeUser}
            onRemove={handleRemoveUserFlow}
            onAdd={handleAddUserFlow}
            onSave={handleEditFlow}
            onReset={resetFlow}
          />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div className="wizard clearfix">
                {loading ?
                  <LoadingData />
                  : <Fragment>
                    {/* แจ้งเตือนค้างไว้ทุกแท็บ เพราะการบันทึกถูกบล็อกทั้งฟอร์ม ไม่ใช่แค่แท็บ 2 */}
                    {behaviorLoadFailed && (
                      <Alert color="danger" className="text-center">
                        <i className="fa-solid fa-triangle-exclamation me-3 fs-3" />
                        {submitErrorMessage.behaviorLoadFailed}
                      </Alert>
                    )}
                    <div className="steps clearfix">
                      <ul>
                        <NavItem className={classnames({ current: activeTab === 1 })}>
                          <NavLink style={{ border: activeTab === 1 ? "2px solid #0d6efd" : "" }} className={`${classnames({ current: activeTab === 1 })} h-100`} onClick={() => { setactiveTab(1); }} disabled={!(passedSteps || []).includes(1)} >
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number">1.</span>
                              </Col>
                              <Col lg={10}>แบบประเมินผลสัมฤทธิ์ของงาน</Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col>
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {calculatedValues.length !== 0
                                        ? `${(calculatedValues * (100 / 5)).toFixed(4)}`
                                        : "0.0000"}
                                    </h4>
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink style={{ backgroundColor: "rgba(161,238,189,0.5)", border: activeTab === 2 ? "2px solid #1EB053" : "" }} className={`${classnames({ active: activeTab === 2 })} h-100`} onClick={() => { setactiveTab(2); }} disabled={!(passedSteps || []).includes(2)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number2" >2.</span>
                              </Col>
                              <Col lg={10}>
                                แบบประเมินพฤติกรรมการปฏิบัติราชการหรือ<br />สมรรถนะ
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col>
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {(
                                        (Number(calculatedValuesForm2) || 0) *
                                        (100 / 5)
                                      ).toFixed(4)}
                                    </h4>
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 3 })}>
                          <NavLink style={{ backgroundColor: "rgba(255,190,125,0.5)", border: activeTab === 3 ? "2px solid #EA7603" : "" }} className={`${classnames({ active: activeTab === 3 })} h-100`} onClick={() => { setactiveTab(3); }} disabled={!(passedSteps || []).includes(3)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number3">3.</span>
                              </Col>
                              <Col lg={10}>แบบสรุปการประเมินผลการปฏิบัติราชการ</Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <Col lg={12} className="mb-2">
                                  คะแนนรวม :{" "}
                                  <Badge color="info" className="ms-2">
                                    <h4 className="m-0">
                                      {formTheeData_1.score !== "" &&
                                        formTheeData_2.score !== ""
                                        ? isNaN(valScore.toFixed(4)) ? "0.0000" : valScore.toFixed(4)
                                        : "0.0000"}
                                    </h4>
                                  </Badge>
                                </Col>
                                <Col lg={12} className="d-flex justify-content-end">
                                  <Badge color="primary text-center">
                                    {valScore > 0 && <strong className="p-2" style={{ fontSize: "1.3rem" }}>{checkEvaluateScoreLevel(valScore)}</strong>}
                                  </Badge>
                                </Col>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 4 })}>
                          <NavLink style={{ backgroundColor: "rgba(246,214,214,0.5)", border: activeTab === 4 ? "2px solid #F54B4B" : "" }} className={`${classnames({ active: activeTab === 4 })} h-100`} onClick={() => { setactiveTab(4); }} disabled={!(passedSteps || []).includes(4)}>
                            <Row className="mb-2">
                              <Col lg={2}>
                                <span className="number4">4.</span>
                              </Col>
                              <Col lg={10}>แผนพัฒนาการปฏิบัติราชการรายบุคคล</Col>
                            </Row>
                            <Row>
                              <Col lg={2}></Col>
                              <Col lg={10}>
                                <div style={{ paddingBottom: "7px" }} />
                                <strong className="fs-5">เรียงลำดับจากมากไปน้อย</strong>
                              </Col>
                            </Row>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="mb-2">
                      {/* <FormAlert
                        isFilledObjectArray={isFilledObjectArray}
                        EditGroup={EditGroup}
                        countSumWeight={countSumWeight}
                        submitError={submitError}
                        setSubmitError={setSubmitError}
                      /> */}
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          <Table bordered responsive>
                            <EvaluateFormHeader mode="INSERT" />
                            <tbody>
                              {
                                EditGroup !== null
                                  ? EditGroup
                                    ?.sort((a, b) => a.no - b.no)?.map((group, groupIndex) => {
                                      return (
                                        <tr key={groupIndex}>
                                          <td className="text-center align-middle">
                                            <div className="d-flex flex-column align-items-center gap-1">
                                              <span className="fw-bold mb-1">{groupIndex + 1}</span>
                                              <div
                                                className="d-flex flex-column border rounded overflow-hidden"
                                                style={{ width: 32 }}
                                              >
                                                {!(groupIndex === 0) && <Button
                                                  title="เลื่อนขึ้น"
                                                  color="light"
                                                  className="border-0 rounded-0 py-1"
                                                  style={{ borderBottom: "1px solid #dee2e6" }}
                                                  onClick={() => handleSwapNo(groupIndex, "up")}
                                                >
                                                  <i className="fa-solid fa-chevron-up text-secondary" style={{ fontSize: 12 }} />
                                                </Button>}
                                                {!(groupIndex === EditGroup.length - 1) && <Button
                                                  title="เลื่อนลง"
                                                  color="light"
                                                  className="border-0 rounded-0 py-1"
                                                  onClick={() => handleSwapNo(groupIndex, "down")}
                                                >
                                                  <i className="fa-solid fa-chevron-down text-secondary" style={{ fontSize: 12 }} />
                                                </Button>}
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ width: "250px" }}>
                                            <Input
                                              style={{ height: "100px" }}
                                              type="textarea"
                                              name={`indicator_${groupIndex}`}
                                              value={group?.indicator}
                                              onChange={e => {
                                                handleInputChange(groupIndex, "indicator", e.target.value);
                                                handleInputChange(groupIndex, "no", group.no);
                                                handleInputChange(groupIndex, "evaluate_salary_result_id", group.evaluate_salary_result_id);
                                              }}
                                            />
                                          </td>
                                          {group.scores.map((score, scoreIndex) => {
                                            let thisScore = Number(score)
                                            const prevValue = scoreIndex > 0 ? group.scores?.[scoreIndex - 1] ?? 0 : 0;
                                            const isValid = (thisScore <= prevValue) && (thisScore > 0)
                                            return (
                                              <td style={{ width: "150px" }} name={`score_${scoreIndex}`} className="text-center" key={scoreIndex}>
                                                <Input
                                                  className={`text-center ${isValid ? "border border-danger border-2" : ""}`}
                                                  type="text"
                                                  value={
                                                    EditGroup?.find(x => x.no === group.no && group.evaluate_salary_result_id === x.evaluate_salary_result_id) ?
                                                      indexArrGrooup.includes(scoreIndex)
                                                        ?
                                                        isNaN(EditGroup?.find(x => x.no === group.no && group.evaluate_salary_result_id === x.evaluate_salary_result_id).scores[scoreIndex]) ? "0.0000"
                                                          : EditGroup?.find(x => x.no === group.no && group.evaluate_salary_result_id === x.evaluate_salary_result_id).scores[scoreIndex]
                                                        : score
                                                      : score
                                                  }
                                                  onChange={e => {
                                                    const inputValue = e.target.value;
                                                    let numericValue = inputValue;
                                                    if (numericValue > 100) {
                                                      numericValue = 100;
                                                    }
                                                    handleInputChange(groupIndex, "no", group.no);
                                                    handleInputChange(groupIndex, "evaluate_salary_result_id", group.evaluate_salary_result_id);
                                                    handleScoreChange(groupIndex, scoreIndex, numericValue);
                                                  }}
                                                />
                                                {isValid && <span className="text-danger">ห้ามน้อยกว่าหรือเท่ากับก่อนหน้า</span>}
                                              </td>
                                            )
                                          })}
                                          <td style={{ width: "100px" }} className="text-center" name={`score_${groupIndex}`}>
                                            <Input
                                              type="text"
                                              className="text-center"
                                              maxlength={4}
                                              value={isNaN(group.score) ? "0.0000" : group.score}
                                              onChange={e => {
                                                const inputValue = e.target.value;
                                                let numericValue = inputValue;
                                                if (numericValue > 5) {
                                                  numericValue = 5;
                                                }
                                                handleInputChange(groupIndex, "score", numericValue);
                                                handleInputChange(groupIndex, "evaluate_salary_result_id", group.evaluate_salary_result_id);
                                              }}
                                              onBlur={() => {
                                                if (group.score !== "" && !isNaN(group.score)) {
                                                  handleInputChange(groupIndex, "score", Number(group.score).toFixed(2));
                                                }
                                              }}
                                            />
                                          </td>
                                          <td style={{ width: "100px" }} className="text-center" name={`weight_${groupIndex}`}>
                                            <Input
                                              maxLength={group.weight !== null && group.weight < 10 ? 4 : group.weight >= 10 && group.weight < 100 ? 5 : Number(group.weight) === 100 && 6}
                                              type="text"
                                              className={`text-center ${((totalWeight < 100 && totalWeight !== 0) || Number(countSumWeight) > 100) ? "border border-danger border-2" : ""}`}
                                              value={isNaN(Number(group?.weight)) ? "" : group.weight}
                                              onChange={e => {
                                                let inputValue = e.target.value;
                                                if (inputValue === "0") {
                                                  inputValue = "1"
                                                }
                                                let numericValue = inputValue;
                                                if (numericValue > 100) {
                                                  numericValue = 100;
                                                }
                                                handleInputChange(groupIndex, "weight", numericValue);
                                                handleInputChange(groupIndex, "evaluate_salary_result_id", group.evaluate_salary_result_id);
                                              }}
                                            />
                                          </td>
                                          <td className="text-center pb-2">
                                            {group.weight !== "" &&
                                              group.score !== "" ? (
                                              <strong>
                                                {isNaN(((group.weight * group.score) / 100).toFixed(4)) ? "0.0000" : ((group.weight * group.score) / 100).toFixed(4)}
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                          <td>
                                            <Col lg={12}>
                                              <FormGroup className="text-center mb-2">
                                                <Button
                                                  color="success"
                                                  type="button"
                                                  onClick={() => handleButtonFileClick(group?.no)}
                                                >
                                                  <i className="fa-solid fa-upload" />
                                                </Button>

                                                <input
                                                  id={`file-input-${group?.no}`}
                                                  type="file"
                                                  accept=".docx,.pdf"
                                                  style={{ display: "none" }}
                                                  onChange={(e) => {
                                                    handleFileChange(e, group?.no);
                                                    handleInputChange(groupIndex, "evaluate_salary_result_id", group.evaluate_salary_result_id);
                                                  }}
                                                />
                                              </FormGroup>
                                              <Row className="justify-content-center text-center">
                                                <Col xs="auto">
                                                {
                                                  fileUploads[group?.no] ? (
                                                    <div className="d-flex align-items-center gap-2 px-2 py-1 rounded bg-success bg-opacity-10">
                                                      <i className="fa-solid fa-file-circle-check text-success" />
                                                      <span className="text-success small text-truncate" style={{ maxWidth: 140 }}>
                                                        {fileUploads[group.no].name}
                                                      </span>
                                                      <Button
                                                        color="link"
                                                        className="p-0 text-danger"
                                                        type="button"
                                                        title="ลบไฟล์ที่เลือก"
                                                        onClick={() => handleRemoveFile(group.no)}
                                                      >
                                                        <i className="fa-solid fa-xmark ps-2" />
                                                      </Button>
                                                    </div>

                                                  ) : (group.file_data && (() => {
                                                        const link = group.file_data.replace("public/", "");
                                                        const filename = group.file_data.replace("./public/evaluate_salary/file/", "");
                                                        const fileExt = group.file_data.split(".").pop();
                                                        const isPdf = fileExt === "pdf";
                                                        const isDoc = fileExt === "doc" || fileExt === "docx";
                                                        const iconName = fileExt === "docx" ? "doc" : fileExt;
                                                        const colorClass = isPdf ? "secondary" : isDoc ? "info" : "secondary";
                                                                                                        
                                                        const dotIndex = filename.lastIndexOf(".");
                                                        const nameOnly = dotIndex !== -1 ? filename.slice(0, dotIndex) : filename;
                                                        const extOnly = dotIndex !== -1 ? filename.slice(dotIndex) : "";

                                                        return (
                                                          <a
                                                            href={`${API_URL}/${link}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className={`d-flex align-items-center gap-2 px-2 py-1 rounded text-decoration-none text-${colorClass}`}
                                                          >
                                                            <i className={`fa-solid fa-file-${iconName}`} style={{ fontSize: 28 }} />
                                                            {/* <span
                                                              className="small d-inline-flex"
                                                              style={{ maxWidth: 140, overflow: "hidden" }}
                                                            >
                                                              <span className="text-truncate">{nameOnly}</span>
                                                              <span className="flex-shrink-0">{extOnly}</span>
                                                            </span> */}
                                                          </a>
                                                        );
                                                      })())
                                                }
                                                </Col>
                                              </Row>

                                              {/* {fileUploads[groupIndex] !== null &&
                                                fileUploads[groupIndex] !== undefined ? (
                                                (() => {
                                                  const file_type = fileUploads[groupIndex]?.name?.split('.')[fileUploads[groupIndex]?.name?.split('.').length - 1]
                                                  const file_style = file_type == "pdf" ? "danger" : (file_type == "doc" || file_type == "docx") && "info"
                                                  return (
                                                    <Row className="align-items-center">
                                                      <Col lg={6}>
                                                        <i className={`fa-solid fa-file-${file_type == "docx" ? "doc" : file_type} fa-2xl fa-beat text-${file_style}`}></i>
                                                      </Col>
                                                      <Col lg={6}>
                                                        <button
                                                          type="button"
                                                          className={`btn btn-link btn-sm text-${file_style}`}
                                                          onClick={() => { handleClearFile(groupIndex); }}
                                                        >
                                                          <i className="fa-solid fa-xmark-large"></i>
                                                        </button>
                                                      </Col>
                                                    </Row>
                                                  )
                                                })()
                                              ) : group.file_data !== null &&
                                                group.file_data !== undefined &&
                                                group.file_data.length !== 0 ? (
                                                (() => {
                                                  const link = group.file_data.split("public/").join("");
                                                  const file_type = group.file_data.split(".")[group.file_data.split(".").length - 1]
                                                  const file_style = file_type == "pdf" ? "danger" : (file_type == "doc" || file_type == "docx") && "info"
                                                  return (
                                                    <a href={`${API_URL}/${link}`} rel="noreferrer" target="_blank">
                                                      <i className={`fa-solid fa-file-${file_type == "docx" ? "doc" : file_type} fa-2xl fa-beat text-${file_style}`}> </i>
                                                    </a>
                                                  );
                                                })()
                                              ) : (
                                                ""
                                              )} */}
                                            </Col>
                                          </td>
                                          <td>
                                            <Button
                                              color="danger"
                                              onClick={() => {
                                                setTask("DELETE")
                                                confrimModalDelete(groupIndex, group.evaluate_salary_result_id)
                                              }}
                                            >
                                              {/* ลบ */}
                                              <i className="fa-solid fa-trash" />
                                            </Button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : ""
                              }
                            </tbody>
                          </Table>
                          <Row>
                            <Col lg={4}>
                              <Button color="primary" onClick={handleAddGroup}>
                                เพิ่ม
                              </Button>
                            </Col>
                          </Row>
                          <InputGroup className="my-2">
                            <Input
                              placeholder="link เอกสารเพิ่มเติม"
                              value={link ?? evaluateDataUser[0]?.evaluate_url_ref ?? ""}
                              onChange={e => setLink(e.target.value)}
                            />
                            <Button color="primary">
                              <Link target="_blank" to={link} style={{ color: "#ffffff" }}>
                                <i className="fa-solid fa-earth-americas"></i>
                              </Link>
                            </Button>
                          </InputGroup>
                        </TabPane>
                        <TabPane tabId={2}>
                          <Table bordered responsive>
                            <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                              <tr>
                                <th className="text-center">สมรรถนะ</th>
                                <th>ระดับที่คาดหวัง</th>
                                <th className="text-center">คะแนน<br />(ก)</th>
                                <th rowSpan="2" className="text-center">น้ำหนัก<br />ร้อยละ<br />(ข)</th>
                                <th rowSpan="2" className="text-center">คะแนนรวม</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formTwoData.map(item => (
                                <tr key={item.id}>
                                  <td>{item.label}</td>
                                  <td className="text-center" style={{ width: "150px" }}>
                                    {checkExpectLevel(dataInfo.user_level_id)}
                                  </td>
                                  <td style={{ width: "100px" }}>
                                    <Input
                                      type="text"
                                      className="text-center"
                                      maxLength={4}
                                      value={item.score ?? ""}
                                      onChange={e => {
                                        let inputValue = e.target.value;
                                        if (!/^\d*\.?\d*$/.test(inputValue)) return;
                                        setFormTwoData(prevData =>
                                          prevData.map(prevItem =>
                                            prevItem.id === item.id ? { ...prevItem, score: inputValue } : prevItem
                                          )
                                        );
                                      }}
                                      onBlur={e => {
                                        let numericValue = parseFloat(e.target.value);
                                        if (!isNaN(numericValue)) {
                                          if (numericValue > 5) numericValue = 5;
                                          if (numericValue < 0) numericValue = 0;
                                          numericValue = numericValue.toFixed(2);
                                          setFormTwoData(prevData =>
                                            prevData.map(prevItem =>
                                              prevItem.id === item.id ? { ...prevItem, score: numericValue } : prevItem
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  </td>
                                  <td className="text-center" style={{ width: "150px" }}>ร้อยละ {item.percentage}</td>
                                  <td className="text-center" style={{ width: "150px" }}>
                                    {item.score !== "" ?
                                      isNaN(((item.score * item.percentage) / 100).toFixed(4)) ? "0.0000"
                                        : ((item.score * item.percentage) / 100).toFixed(4)
                                      : ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </TabPane>
                        <TabPane tabId={3}>
                          <Table bordered responsive>
                            <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                              <tr>
                                <th className="text-center">องค์ประกอบการประเมิน</th>
                                <th className="text-center">คะแนน<br />(ก)</th>
                                <th rowSpan="2" className="text-center">สัดส่วนคะแนน<br />(น้ำหนัก) (ข)</th>
                                <th rowSpan="2" className="text-center">รวมคะแนน<br />(ก)x(ข)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{formTheeData_1.label}</td>
                                <td className="text-center" style={{ width: "150px" }}>{isNaN(Number(formTheeData_1?.score))? "-" : formTheeData_1?.score}</td>
                                <td className="text-center" style={{ width: "150px" }}>{formTheeData_1.percentage}%</td>
                                <td className="text-center" style={{ width: "150px" }}>
                                  {!isNaN(Number(formTheeData_1?.score)) &&
                                  !isNaN(Number(formTheeData_1?.percentage))
                                   ? (
                                       ((Number(formTheeData_1.score) * Number(formTheeData_1.percentage)) / 100).toFixed(4)
                                     )
                                   : ""}
                                </td>
                              </tr>
                              <tr>
                                <td>{formTheeData_2.label}</td>
                                <td className="text-center" style={{ width: "150px" }}>{isNaN(Number(formTheeData_2?.score))? "0.0000" : formTheeData_2?.score}</td>
                                <td className="text-center" style={{ width: "150px" }}>{formTheeData_2.percentage}%</td>
                                <td className="text-center" style={{ width: "150px" }}>
                                  {!isNaN(Number(formTheeData_2?.score)) &&
                                  !isNaN(Number(formTheeData_2?.percentage))
                                   ? (
                                       ((Number(formTheeData_2.score) * Number(formTheeData_2.percentage)) / 100).toFixed(4)
                                     )
                                   : "0.0000"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </TabPane>
                        <TabPane tabId={4}>
                          <Table bordered responsive>
                            <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                              <tr>
                                <th className="text-center">ลำดับ</th>
                                <th className="text-center">หัวข้อการพัฒนา</th>
                                <th colSpan={7} className="text-center">การพัฒนาตนเอง</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                evaluateDataDevelopment.length !== 0
                                  ? evaluateDataDevelopment
                                    .slice()
                                    .sort((a, b) => a.no - b.no)
                                    .map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td className="text-center" style={{ width: "60px" }}>{item.no}</td>
                                          <td>
                                            <DevelopmentTopicSelect
                                              placeholderValue="0"
                                              defaultValue={item.development_type_id}
                                              onChange={e => {
                                                handleDevelopmentChange(index + 1, "topic", e.target.value);
                                                handleDevelopmentChange(index + 1, "evaluate_salary_development_id", item.evaluate_salary_development_id);
                                              }}
                                            />
                                          </td>
                                          <td className="text-center" style={{ width: "700px" }}>
                                            <Input
                                              style={{ height: "100px" }}
                                              type="textarea"
                                              placeholder="ระบุหลักสูตร/วิธีการ/แนวทางที่ต้องการ"
                                              defaultValue={item.development}
                                              onChange={e => {
                                                handleDevelopmentChange(index + 1, "description", e.target.value);
                                                handleDevelopmentChange(index + 1, "evaluate_salary_development_id", item.evaluate_salary_development_id);
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : formFourData.map((item, index) => (
                                    <tr key={item.id}>
                                      <td className="text-center" style={{ width: "60px" }}>{item.id}</td>
                                      <td>
                                        <DevelopmentTopicSelect
                                          placeholderValue="0"
                                          onChange={e => {
                                            handleDevelopmentChange(item.id, "topic", e.target.value);
                                            handleDevelopmentChange(index + 1, "evaluate_salary_development_id", item.evaluate_salary_development_id);
                                          }}
                                        />
                                      </td>
                                      <td className="text-center" style={{ width: "700px" }}>
                                        <Input
                                          style={{ height: "100px" }}
                                          type="textarea"
                                          placeholder="ระบุหลักสูตร/วิธีการ/แนวทางที่ต้องการ"
                                          defaultValue={item.description}
                                          onChange={e =>
                                            handleDevelopmentChange(item.id, "description", e.target.value)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                              }
                            </tbody>
                          </Table>

                          {/* {(status === "1" || status === "4") ? (
                            <Button
                              className="me-2"
                              color="warning"
                              onClick={() => {
                                setTask("DRAFT")
                                setconfirmModal(true)
                              }}
                            >
                              บันทึกร่าง
                            </Button>
                          ) : (
                            ""
                          )} */}

                          {evaluate_salary_approve_id ? <Button
                            className="me-2 text-center"
                            color="warning"
                            disabled={isUpdate || behaviorLoadFailed}
                            onClick={() => {
                              setTask("DRAFT")
                              setconfirmModal(true)
                            }}
                          >
                            {isUpdate ? <SpinerSubmit /> : "บันทึกร่าง"}
                          </Button> : null}

                          {evaluate_salary_approve_id ? <Button
                            className="me-2"
                            color="success"
                            disabled={isSubmitting || behaviorLoadFailed}
                            onClick={() => {
                              setTask("SUBMIT")
                              setconfirmModal(true)
                            }}
                          >
                            {isSubmitting ? <SpinerSubmit /> : evaluate_salary_approve_id ? "อนุมัติการประเมิน" : "ส่งแบบประเมิน"}
                          </Button> : null}
                          {evaluate_salary_approve_id && !(userPosition.find(x => x.position_id === 3)) ? (
                            <ButtonGroup>
                              <UncontrolledDropdown>
                                <DropdownToggle caret className="me-2" color="danger"
                                  disabled={behaviorLoadFailed}
                                  // disabled={(isUpdateSuccess === null) || (isUpdateSuccess === false)}
                                >
                                  ส่งกลับ
                                  <i className="fa-solid fa-caret-down ps-2"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  {evaluateData && evaluateData.map((item, idx) => {
                                    return (item.approve_user_id !== null &&
                                      item.approve_status !== "2" &&
                                      item.approve_user_id !== approve_user_id &&
                                      <DropdownItem key={idx}
                                        onClick={() => {
                                          setTask("SENDBACK")
                                          confrimModalAscept(item.evaluate_salary_id, item.evaluate_salary_approve_id, item.user_id, item.approve_user_id, item.approve_user)
                                        }}
                                      >
                                        {item.approve_user}
                                      </DropdownItem>
                                    )
                                  })}
                                  {evaluateDataUser && evaluateDataUser.map((item, idx) => {
                                    return (
                                      <DropdownItem key={idx}
                                        onClick={() => {
                                          setTask("SENDBACKUSER")
                                          confrimModalAsceptUser(item.evaluate_salary_id, item.user_id, item.user_id, item.user_name)
                                        }}
                                      >
                                        {item.user_name}
                                      </DropdownItem>
                                    )
                                  })}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </ButtonGroup>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          </TabPane>
                      </TabContent>

                      <Col lg={12}>
                        <EvaLuateFormAlert
                          isFilledObjectArray={isFilledObjectArray}
                          EditGroup={EditGroup}
                          countSumWeight={countSumWeight}
                          submitError={submitError}
                          setSubmitError={setSubmitError}
                        />
                        {isUpdateSuccess === true && (
                          <span className="text-success pt-3">บันทึกร่างสำเร็จ</span>
                        )}

                        <Modal
                          isOpen={isUpdateSuccess === false}
                          toggle={() => setIsUpdateSuccess(null)}
                          centered
                        >
                          <ModalHeader toggle={() => setIsUpdateSuccess(null)} className="text-danger">
                            <i className="fa-solid fa-circle-exclamation me-2" />
                            บันทึกร่างไม่สำเร็จ
                          </ModalHeader>
                          {/* <ModalBody>
                            เกิดข้อผิดพลาดในการบันทึกฉบับร่าง กรุณาลองใหม่อีกครั้ง
                            หากยังไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ
                          </ModalBody> */}
                          {/* <ModalFooter>
                            <Button color="danger" onClick={() => setIsUpdateSuccess(null)}>
                              ปิด
                            </Button>
                          </ModalFooter> */}
                        </Modal>
                      </Col>
                      {user_id === user.user_id ? <Col>
                          <Button
                            className="me-2 text-center"
                            color="warning"
                            disabled={isUpdate || behaviorLoadFailed}
                            onClick={() => {
                              setTask("DRAFT")
                              setconfirmModal(true)
                            }}
                          >
                            {isUpdate ? <SpinerSubmit /> : "บันทึกร่าง"}
                          </Button>

                          <Button
                            className="me-2"
                            color="success"
                            disabled={isSubmitting || behaviorLoadFailed}
                            onClick={handleClickSubmit}
                          >
                            {isSubmitting ? <SpinerSubmit /> : "ส่งแบบประเมิน"}
                          </Button>
                      </Col> : null
                      // (evaluate_salary_approve_id && <Col>
                      //     <Button
                      //       className="me-2 text-center"
                      //       color="warning"
                      //       onClick={() => {
                      //         setTask("DRAFT")
                      //         setconfirmModal(true)
                      //       }}
                      //     >
                      //       {isUpdate ? <SpinerSubmit /> : "บันทึกร่าง"}
                      //     </Button>
                      //     <Button
                      //       className="me-2"
                      //       color="success"
                      //       onClick={() => {
                      //         setTask("SUBMIT")
                      //         setconfirmModal(true)
                      //       }}
                      //     >
                      //       {evaluate_salary_approve_id ? "อนุมัติการประเมิน" : "ส่งแบบประเมิน"}
                      //     </Button>
                      //     {evaluate_salary_approve_id && !(userPosition.find(x => x.position_id === 3)) ? (
                      //       <ButtonGroup>
                      //         <UncontrolledDropdown>
                      //           <DropdownToggle caret className="me-2" color="danger"
                      //             // disabled={(isUpdateSuccess === null) || (isUpdateSuccess === false)}
                      //           >
                      //             ส่งกลับ
                      //             <i className="fa-solid fa-caret-down ps-2"></i>
                      //           </DropdownToggle>
                      //           <DropdownMenu>
                      //             {evaluateData && evaluateData.map((item, idx) => {
                      //               return (item.approve_user_id !== null &&
                      //                 item.approve_status !== "2" &&
                      //                 item.approve_user_id !== approve_user_id &&
                      //                 <DropdownItem key={idx}
                      //                   onClick={() => {
                      //                     setTask("SENDBACK")
                      //                     confrimModalAscept(item.evaluate_salary_id, item.evaluate_salary_approve_id, item.user_id, item.approve_user_id, item.approve_user)
                      //                   }}
                      //                 >
                      //                   {item.approve_user}
                      //                 </DropdownItem>
                      //               )
                      //             })}
                      //             {evaluateDataUser && evaluateDataUser.map((item, idx) => {
                      //               return (
                      //                 <DropdownItem key={idx}
                      //                   onClick={() => {
                      //                     setTask("SENDBACKUSER")
                      //                     confrimModalAsceptUser(item.evaluate_salary_id, item.user_id, item.user_id, item.user_name)
                      //                   }}
                      //                 >
                      //                   {item.user_name}
                      //                 </DropdownItem>
                      //               )
                      //             })}
                      //           </DropdownMenu>
                      //         </UncontrolledDropdown>
                      //       </ButtonGroup>
                      //     ) : (
                      //       ""
                      //     )}
                      // </Col>
                      // )
                      }
                    </div>
                    <div className="actions clearfix ms-2">
                      <ul>
                        <li style={{ cursor: activeTab === 1 ? "not-allowed" : "" }} className={`${activeTab === 1 ? "previous disabled" : "previous"} mt-2`}>
                          <Button disabled={activeTab === 1} color="primary" onClick={() => { toggleTab(activeTab - 1) }}>
                            ย้อนกลับ
                          </Button>
                        </li>
                        <li style={{ cursor: totalWeight < 100 ? "pointer" : activeTab === 4 ? "not-allowed" : "" }} className={`${activeTab === 4 ? "next disabled" : "next"} mt-2`}>
                          <Tooltip title={totalWeight < 100 ? "ต้องกรอกแบบประเมินผลสัมฤทธิ์ของงานและกรอกน้ำหนักร้อยละให้ครบ 100" : ""}>
                            <span>
                              <button
                                className="btn btn-primary"
                                disabled={nextButtonDisable}
                                color="primary" onClick={() => { toggleTab(activeTab + 1) }}>
                                ถัดไป
                              </button>
                            </span>
                          </Tooltip>
                        </li>
                      </ul>
                    </div>
                    <ConfirmModal
                      modal={confirmModal}
                      modalSize="md"
                      modalHeaderContent={
                        task === "DRAFT" ? "ต้องการที่จะบันทึกฉบับร่าง ใช่หรือไม่"
                          :
                          task === "SUBMIT" ? "ต้องการที่จะส่งแบบประเมินให้"
                            :
                            task === "SENDBACK" ? "ต้องการที่จะส่งกลับแบบประเมิน ใช่หรือไม่"
                              :
                              task === "SENDBACKUSER" ? "ต้องการที่จะส่งกลับแบบประเมิน ใช่หรือไม่"
                                :
                                task === "DELETE" ? `ลบลำดับที่ ${AcceptedgroupIndex + 1}`
                                  : ""
                      }
                      taskName={task === "SUBMIT" ? nextLvApproveName : ""}
                      onClickConfirmBtn={async () => {
                        // await เพื่อให้ ConfirmModal ล็อกปุ่มยืนยันไว้จนกว่างานจะเสร็จจริง
                        if (task === "DRAFT") {
                          await handleDraft(evaluate_salary_approve_id);
                        } else if (task === "SUBMIT") {
                          await handleSubmit("normal");
                          if (evaluate_salary_approve_id) {
                            await handleCheck()
                          }
                        } else if (task === "SENDBACK") {
                          await handleSendBack(Acceptedevaluate_salary_id, Acceptedevaluate_salary_approve_id, Accepteduser_id, Acceptedapprove_user_id, Acceptedapprove_user);
                        } else if (task === "SENDBACKUSER") {
                          handleSendBackUser(Acceptedevaluate_salary_id, Accepteduser_id, Acceptedapprove_user_id, Acceptedapprove_user);
                        } else if (task === "DELETE") {
                          handleRemoveGroup(AcceptedgroupIndex);
                        }
                        setconfirmModal(false)
                      }}
                      onClickCancelBtn={() => {
                        setconfirmModal(false)
                      }}
                    />
                  </Fragment>
                }
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default EditEvaluateForm;